import { patchState, signalStore, withComputed, withHooks, withMethods, withState } from '@ngrx/signals';
import { getCompatibleVersions } from 'baseline-browser-mapping';
import { computed } from '@angular/core';
import UAParser from 'my-ua-parser';

const ANGULAR_VERSION_RELEASE_DATE = '2026-03-11';
const SESSION_STORAGE_KEY = 'browser-support-banner-closed';

const INITIAL_STATE = {
  currentBrowser: UAParser(navigator.userAgent),
  compatibleBrowser: getCompatibleVersions({
    widelyAvailableOnDate: ANGULAR_VERSION_RELEASE_DATE,
  }),
  hasUserClosedBanner: false,
};

export const BrowserSupportStore = signalStore(
  { providedIn: 'root' },
  withState(INITIAL_STATE),
  withMethods(store => {
    const updateUserSelection = (hasUserClosedBanner: boolean) => {
      // Manuell session storage manipulation -> Info should not be app bound
      sessionStorage.setItem(SESSION_STORAGE_KEY, `${hasUserClosedBanner}`);
      patchState(store, { hasUserClosedBanner });
    };
    return {
      updateUserSelection,
    };
  }),
  withComputed(store => {
    const isCurrentBrowserCompatible = computed(() => {
      const { name, version } = store.currentBrowser().browser;
      const { type } = store.currentBrowser().device;
      const compatibleBrowser = store.compatibleBrowser();

      let browserName = name;

      const filteredBrowsers = compatibleBrowser.filter(browser => {
        if ((type === 'mobile' || type === 'tablet') && !browserName.toLowerCase().includes('safari')) {
          return (
            browser.browser?.toLowerCase()?.includes(browserName?.toLowerCase()) && browser.browser?.toLowerCase()?.includes('android')
          );
        }

        /*
         * If the mobile safari is used, the mutation is needed; otherwise the comparison doesn't work
         * Mobile Safari and Desktop Safari usually have the same featureset
         * Mobile Safari => Safari
         * */

        if ((type === 'mobile' || type === 'tablet') && name.toLowerCase().includes('safari')) {
          browserName = name.split(' ')?.[1];
        }
        return (
          browser?.browser?.toLowerCase()?.includes(browserName?.toLowerCase()) && !browser.browser?.toLowerCase()?.includes('android')
        );
      });

      return filteredBrowsers.some(browser => parseInt(version) >= parseInt(browser.version));
    });
    const showIncompatibilityBanner = computed(() => {
      return !isCurrentBrowserCompatible() && !store.hasUserClosedBanner();
    });
    return {
      isCurrentBrowserCompatible,
      showIncompatibilityBanner,
    };
  }),
  withHooks(store => ({
    onInit() {
      const userSelection = sessionStorage.getItem(SESSION_STORAGE_KEY);
      if (!userSelection) {
        return;
      }
      store.updateUserSelection(Boolean(userSelection));
    },
  })),
);
